import React from 'react';
import { ArrowUpward } from '@material-ui/icons';
import { CommonPromptBox } from '../../components/ui';

const EnviroChemicalAIInput = ({ value, onChange, onEnter, textareaRef }: any) => {
  return (
    <div style={{ width: '100%', maxWidth: 720, margin: '0 auto' }}>
      <CommonPromptBox
        value={value}
        onChange={onChange}
        onSubmit={onEnter}
        className="cmn-chem-searchbox"
        variant="hero"
        placeholder="Ask Enviro Chemical AI"
        inputRef={textareaRef}
        submitIcon={<ArrowUpward className="cmn-chem-searchbox__send-icon" style={{ fontSize: 22 }} />}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            onEnter();
          }
        }}
      />
    </div>
  );
};

export default EnviroChemicalAIInput;

